import { ChevronDown, ChevronUp } from 'baseui/icon'
import { HomeMessage, MessageLabels } from '../types'

interface UseMessageCardParams {
  message: HomeMessage
  expanded: boolean
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const useMessageCard = ({ message, expanded, labels, onToggle }: UseMessageCardParams) => ({
  title: message.title || labels.untitled,
  Chevron: expanded ? ChevronUp : ChevronDown,
  onClick: () => onToggle(message),
})

export default useMessageCard
